'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var radioChecked = require('./radio-checked-1788a82f.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
var fieldLabel = require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  font: 14px/22px ", ";\n  padding: 15px;\n\n  ", ";\n  ", "\n"], ["\n  display: flex;\n  font: 14px/22px ", ";\n  padding: 15px;\n\n  ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && 'opacity: .5';
}, function (_a) {
    var withContent = _a.withContent, checked = _a.checked, theme = _a.theme;
    return (withContent && "\n  box-shadow: 0 2px 10px rgba(54, 54, 54, 0.2);\n  border-radius: 12px;\n  border: " + (checked ? "2px solid " + theme.colors.floorPlan.blue : 'none') + ";\n  user-select: none;\n");
});
var StyledRadio = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    flex-shrink: 0;\n    cursor: ", ";\n    position: relative;\n\n    .radio-icon {\n      display: block;\n      position: relative;\n      top: 1px;\n      transition: .3s;\n\n      &::before {\n        content: '';\n        display: none;\n        width: 40px;\n        height: 40px;\n        padding: 10px;\n        border-radius: 50%;\n        background: ", ";\n        position: absolute;\n        top: -10px;\n        left: -10px;\n        z-index: -1;\n      }\n    }\n\n    &:hover .radio-icon::before {\n      ", ";\n    }\n"], ["\n    flex-shrink: 0;\n    cursor: ", ";\n    position: relative;\n\n    .radio-icon {\n      display: block;\n      position: relative;\n      top: 1px;\n      transition: .3s;\n\n      &::before {\n        content: '';\n        display: none;\n        width: 40px;\n        height: 40px;\n        padding: 10px;\n        border-radius: 50%;\n        background: ", ";\n        position: absolute;\n        top: -10px;\n        left: -10px;\n        z-index: -1;\n      }\n    }\n\n    &:hover .radio-icon::before {\n      ", ";\n    }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var disabled = _a.disabled;
    return (!disabled && 'display: block');
});
var StyledInput = styled__default.input(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  top: 0;\n  left: 0;\n  width: 100%;\n  cursor: inherit;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  z-index: 1;\n  position: absolute;\n"], ["\n  top: 0;\n  left: 0;\n  width: 100%;\n  cursor: inherit;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  z-index: 1;\n  position: absolute;\n"])));
var SubLabel = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font-size: 12px;\n  font-weight: normal;\n  color: ", ";\n\n  ", "\n"], ["\n  font-size: 12px;\n  font-weight: normal;\n  color: ", ";\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var isTextTruncated = _a.isTextTruncated;
    return (isTextTruncated && "\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n");
});
var StyledFieldLabel = styled__default(fieldLabel.FieldLabel)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  margin-left: 6px;\n  cursor: ", ";\n\n  ", ";\n"], ["\n  color: ", ";\n  margin-left: 6px;\n  cursor: ", ";\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var children = _a.children;
    return children && 'font-weight: 500';
});
var ContentContainer = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Label = styled__default.label(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var RadioButton = function (_a) {
    var isExpandedTouchArea = _a.isExpandedTouchArea, id = _a.id, _b = _a.selectedValue, selectedValue = _b === void 0 ? null : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, name = _a.name, label = _a.label, subLabel = _a.subLabel, onChange = _a.onChange, required = _a.required, value = _a.value, isErrored = _a.isErrored, className = _a.className, content = _a.content, _d = _a.isTextTruncated, isTextTruncated = _d === void 0 ? false : _d, _e = _a.withContent, withContent = _e === void 0 ? false : _e, rest = tslib_es6.__rest(_a, ["isExpandedTouchArea", "id", "selectedValue", "disabled", "name", "label", "subLabel", "onChange", "required", "value", "isErrored", "className", "content", "isTextTruncated", "withContent"]);
    var checked = selectedValue === value;
    var fieldLabel = label || value;
    var radioId = id || name + "-" + (fieldLabel === null || fieldLabel === void 0 ? void 0 : fieldLabel.toLowerCase().replace(/\s/g, '-'));
    var Icon = checked ? radioChecked.RadioChecked : radioChecked.Radio;
    var checkedVariant = checked ? 'primary' : 'adminGreyDark';
    var variant = isErrored ? 'pink' : checkedVariant;
    var ContainerElement = (React__default.createElement(Container, { disabled: disabled, className: "radio-group-item " + className, withContent: withContent, checked: checked },
        React__default.createElement(StyledRadio, { disabled: disabled },
            React__default.createElement(StyledInput, tslib_es6.__assign({ id: radioId, type: "radio", name: name, checked: checked, disabled: disabled, required: required, onChange: onChange, value: value }, rest)),
            React__default.createElement("div", { className: "radio-icon" },
                React__default.createElement(Icon, { size: "md", variant: variant, "data-testid": "radio-icon-" + variant }))),
        React__default.createElement(StyledFieldLabel, { label: fieldLabel, htmlFor: radioId, disabled: disabled, required: required },
            subLabel && React__default.createElement(SubLabel, { isTextTruncated: isTextTruncated }, subLabel),
            content && React__default.createElement(ContentContainer, { className: "radio-button-content" }, content))));
    return isExpandedTouchArea ? (React__default.createElement(Label, { htmlFor: value }, ContainerElement)) : ContainerElement;
};

exports.RadioButton = RadioButton;
